// extracted by mini-css-extract-plugin
export default {"heroWrapper":"Hero_heroWrapper__wgNJj","heroContent":"Hero_heroContent__7kjMG","imageWrapper":"Hero_imageWrapper__pquFK","gradientOverlay":"Hero_gradientOverlay__wlUJi"};